import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'mkg-confirm-apply-low',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CurrencyPipe,

    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './confirm-apply-low.component.html',
  styleUrl: './confirm-apply-low.component.scss'
})
export class ConfirmApplyLowComponent {
  options = ApplyLowOptions;

  /** é desconto se o valor informado é menor que o valor da provisão*/
  isDiscount: boolean;
  diference: number;

  constructor(
    public dialogRef: MatDialogRef<ConfirmApplyLowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmApplyLowData
  ) {
    this.isDiscount = data.valueInformed < data.valueProvisioned;
    this.diference = Math.abs(data.valueInformed - data.valueProvisioned);
  }

  onOptionClick(option: ApplyLowOptions): void {
    this.dialogRef.close(option);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}

export interface IConfirmApplyLowData {
  valueProvisioned: number,
  valueInformed: number
}

export enum ApplyLowOptions {
  /** Apply discount (value lower than original) */
  DISCOUNT = 1,
  /** Apply interest/surcharge (amount greater than original) */
  SURCHARGE = 2,
  /** Keep remaining balance open (partial) */
  PARTIAL = 3,
  /** Reset the title balance (finalize even with discrepancy) */
  FINALIZE = 4
}
